
(function(){
	
	"use strict";
	
	var smoothScroll;
	
	smoothScroll = function(gap){
		
		var
			$target = $('a.is-smoothScroll'),
			smooth
			;
		
		smooth = function(e){
			
			var position = this.href.split('#')[1];
			
			e.preventDefault();
			
			position = (position==='' || !document.getElementById(position)) ? 0 : $(document.getElementById(position)).offset().top;
			
			$('html, body').animate(
				{'scrollTop':position+gap},
				400,
				'swing');
			
		};
		
		if($target.length===0){
			
			$('a[href^=#]').click(smooth);
			
		}else{
			
			$target.click(smooth);
			
		}
		
	};
	
	
	$(function(){
		
		if(0<window.location.href.indexOf('story')) {
			
			smoothScroll(-20);
			
		}else{
			
			$('.s-colorbox-1').colorbox({
				'rel' : 's-colorbox-1',
				'returnFocus' : false
			});
			$('.s-colorbox-2').colorbox({
				'rel':'s-colorbox-2',
				'returnFocus' : false
			});
			
			smoothScroll(10);
			
		}
		
	});
	
	 
}());